import { BottomSheet } from 'shared/ui/BottomSheet'
import { Text, TextAlign, TextSize, TextWeight } from 'shared/ui/Text/Text'
import cls from './AnnounceFloat.module.scss'
import whale from 'shared/assets/images/whaleCool.png'
import { Button } from 'shared/ui/Button'
import React from 'react'

export const AnnounceFloat = (props) => {
    const { closeAnnounceFloat, navigateToSuggest, open = true } = props

    return (
        <BottomSheet
            label="Коллекция скоро появится"
            onOpenChange={(open) => !open && closeAnnounceFloat()}
            open={open}
        >
            <img className={cls.FloatWhale} src={whale} alt="whale" />
            <Text
                className={cls.TitleTextFloat}
                size={TextSize.XL}
                align={TextAlign.LEFT}
                weight={TextWeight.BOLD}
            >
                Коллекция скоро появится
            </Text>
            <Text
                className={cls.TextFloat}
                align={TextAlign.LEFT}
                weight={TextWeight.MED}
            >
                Создавай мечты которые хочешь увидеть в ней
            </Text>
            <Button
                onClick={navigateToSuggest}
                className={cls.FloatButton}
                text={'Создать свою мечту'}
            />
        </BottomSheet>
    )
}
